






































































































































































































































































































































































































































import store, { LifeCycle, Scenario } from '../store'
import { inputs, printExport } from '../mixins/mixins'
import fields, { Assumption, Cost } from '../data/fields'

export default {
  mixins: [ inputs, printExport ],

  data (this:any) {
    return {
      title: 'Data Entry',
      help: false,
      disable: false,
      updateCostsKey: 0,
      updateAssumptionsKey: 0,
      scenario: null,
      scenarioName: 'Default',
      scenarioLifeCycle: 'Perennial',
      lifeCycles: ['Perennial', 'Short term'],
      saved: {
        status: false,
        timeout: 1500,
        message: 'Scenario saved.'
      },
      costsHeaders: fields.costsHeaders,
      assumptionsHeaders: fields.assumptionsHeaders,
      areas: {
        perennial: 10,
        shortTerm: 10
      },
      totals: {
        perennial: { dev: 0, main: 0, res: 0, all: 0 },
        shortTerm: { dev: 0, main: 0, res: 0, all: 0 }
      },
      costs: {
        perennial: this.cleanSource(fields.costs.perennial),
        shortTerm: this.cleanSource(fields.costs.shortTerm)
      },
      assumptions: {
        perennial: this.cleanSource(fields.assumptions.perennial),
        shortTerm: this.cleanSource(fields.assumptions.shortTerm)
      }
    }
  },

  created: function (this:any) {
    this.saved.status = false
    // Update on route creation
    this.updateScenario(store.state.selectedScenario)
    // Create reference to this component
    this.$root.$refs.dataEntry = this;
  },

  watch: {
    // If scenario name matches existing scenario, select that scenario
    scenarioName: function (this:any) {
      let hasScenario = store.state.scenarios.map((s:Scenario) => s.text).indexOf(this.scenarioName)
      if (hasScenario > -1) {
        this.updateScenario(store.state.scenarios[hasScenario])
      }
    },

    // Enforce min value of 1
    /*scenarioArea: function (this:any) {
      if (this.scenarioArea < 1) {
        this.scenarioArea = 1
      }
    },*/

    scenarioLifeCycle: async function (this:any) {
      // Inherit values from perennial data
      // this.inheritPerennialValues();
      // Clear validation warnings on life cycle change
      (this.$refs.generalAssumptions as Vue & { reset: () => boolean }).reset();
      // Prompt user to create perennial before short time scenario
      /*if (
        this.scenarioLifeCycle === 'Short term' &&
        (this.assumptions.perennial.filter((a:Assumption) => (a.value === null || a.value === undefined || a.value === '')).length > 0 ||
        this.totals.perennial.all <= 0)
      ) {
        await this.$refs.confirm.open(
          'Warning',
          'You must enter and save perennial data for this scenario before you can create a short term plan.',
          {
            color: 'amber',
            cta: 'Okay'
          }
        )
        this.scenarioLifeCycle = 'Perennial'
      }*/
      this.updateAssumptionsKey += 1
    }
  },

  computed: {
    lifeCycleKey: function (this:any) {
      return this.scenarioLifeCycle === 'Perennial' ? 'perennial' : 'shortTerm'
    },

    // The current selected / active scenario
    selectedScenario: {
      // If scenarios exist, get first array item
      get: function () {
        if (store.state.scenarios.length > 0) {
          return store.state.scenarios[0]
        }
        return 0
      },
      // Update tables when scenario is selected
      set: function (this:any, newValue:Scenario) {
        this.scenario = newValue
        store.dispatch('updateSelectedScenario', newValue)
      }
    },
    // Return the areas for the selected life cycle
    areasLC(this:any) {
      return this.scenarioLifeCycle === "Perennial" ? this.areas.perennial : this.areas.shortTerm
    },
    // Return the totals for the selected life cycle
    totalsLC(this:any) {
      return this.scenarioLifeCycle === "Perennial" ? this.totals.perennial : this.totals.shortTerm
    },
    // Return the costs for the selected life cycle
    costsLC(this:any) {
      return this.scenarioLifeCycle === "Perennial" ? this.costs.perennial : this.costs.shortTerm
    },
    // Return the assumptions for the selected life cycle
    assumptionsLC(this:any) {
      return this.scenarioLifeCycle === "Perennial" ? this.assumptions.perennial : this.assumptions.shortTerm
    }
  },

  methods: {

    // Get cost per hectare - item cost / area
    getCostPerHa: function (this:any, cost:number) {
      let costPerHa = cost / this.areasLC
      return isNaN(costPerHa) ? 0 : costPerHa
    },

    // SCENARIO

    // Remove reactivity from data source
    cleanSource: function (source:any) {
      return JSON.parse(JSON.stringify(source))
    },

    // Select scenario
    selectScenario: function (this:any, event:any) {
      if (event !== undefined) {
        this.scenario = this.cleanSource(event)
        this.scenarioName = this.cleanSource(event.name)
        this.areas = this.cleanSource(event.areas)
        this.scenarioLifeCycle = this.cleanSource(event.lifeCycle)
        this.totals = this.cleanSource(event.totals)
        this.costs = this.cleanSource(event.costs)
        this.assumptions = this.cleanSource(event.assumptions)
        store.state.errors.splice(store.state.errors.indexOf('Scenario Name'), 1)
        store.state.errors.splice(store.state.errors.indexOf('Scenario Area'), 1)
      }
      this.updateCostsKey += 1
      this.updateAssumptionsKey += 1
    },

    // Update scenario
    updateScenario: function (this:any, scenario:Scenario) {
      if (scenario !== null) {
        this.selectedScenario = scenario
        this.scenarioName = scenario.value.name
        this.areas = scenario.value.areas
        this.scenarioLifeCycle = scenario.value.lifeCycle || 'Perennial'
        this.totals = scenario.value.totals
        this.costs = scenario.value.costs
        this.assumptions = scenario.value.assumptions
        this.updateCostsKey += 1
        this.updateAssumptionsKey += 1
      }
    },

    // Set short term values
    /*inheritPerennialValues: function (this:any) {
      this.assumptions.shortTerm.map((ast:Assumption) => {
        if (ast.readonly && ast.id === 'stockingRateBefore') {
          ast.value = this.assumptions.perennial.filter((ap:Assumption) => ap.id === 'stockingRateBefore')[0].value
        }
        if (ast.readonly && ast.id === 'grossMarginBefore') {
          ast.value = this.assumptions.perennial.filter((ap:Assumption) => ap.id === 'grossMarginBefore')[0].value
        }
      })
    },*/

    // Save scenario
    saveScenario: function (this:any) {
      // Deny if no name is provided
      if (this.scenarioName === '') {
        this.saved.message = 'Scenario must be given a name before it can be saved.'
        this.saved.status = true
        return 0
      }
      // this.inheritPerennialValues();
      // Save total value of the costs table
      this.totalsLC.dev = this.getTotal([0, this.totalIndex(this.scenarioLifeCycle === 'Perennial' ? 'Post-sow spraying' : 'Additional livestock labour')])
      this.totalsLC.main = this.getTotal([this.totalIndex('Fertiliser application'), this.totalIndex(this.scenarioLifeCycle === 'Perennial' ? 'Additional livestock labour' : 'Herbicides / pesticides')])
      this.totalsLC.res = this.getTotalResidual()
      this.totalsLC.all = this.totalsLC.dev + this.totalsLC.main
      // Create new scenario object
      let scenarioObject:Scenario = {
        text: this.scenarioName,
        date: new Date(),
        value: {
          name: this.scenarioName,
          areas: this.areas,
          lifeCycle: this.scenarioLifeCycle,
          totals: this.totals,
          costs: this.cleanSource(this.costs),
          assumptions: this.cleanSource(this.assumptions)
        }
      }
      // Get index of new scenario name and value
      let nameIndex = store.state.scenarios.length > 0 ? store.state.scenarios.map((s:Scenario) => s.text).indexOf(this.scenarioName) : -1
      let valueIndex = store.state.scenarios.map((s:Scenario) => { return s.value }).indexOf(scenarioObject.value)
      // If scenario exists 'update' object else push new object to array
      if (valueIndex < 0) {
        // Update
        if (nameIndex > -1) {
          store.state.scenarios[nameIndex] = scenarioObject
          this.saved.message = 'Scenario ' + this.scenarioName + ' updated.'
        // Save
        } else {
          store.state.scenarios.push(scenarioObject)
          // Automatically select new scenario
          this.selectedScenario = store.state.scenarios[store.state.scenarios.length - 1]
          this.saved.message = 'Scenario ' + this.scenarioName + ' saved.'
        }
        store.dispatch('updateSelectedScenario', scenarioObject)
      // Else alert error message
      } else {
        this.saved.message = 'Either a scenario with these values already exists, or no changes have been made.'
      }
      this.saved.status = true
      // Validate
      this.validation()
      // Update state
      store.dispatch('updateScenarios', store.state.scenarios)
    },

    // Reset to default state
    clearScenario: async function (this:any, deleteScenario:boolean, lifeCycle?: LifeCycle) {
      if (!deleteScenario && this.scenario) {
        if (await this.$refs.confirm.open(
          'Clear scenario',
          'Are you sure you want to clear all fields in this scenario: ' + this.scenario.text,
          {
            color: 'red',
            cta: 'Okay'
          }
        )) {
          if (lifeCycle) {
            if (lifeCycle === 'Perennial') {
              this.totals.perennial = { dev: 0, main: 0, res: 0, all: 0 }
              this.costs.perennial = this.cleanSource(fields.costs.perennial)
              this.assumptions.perennial = this.cleanSource(fields.assumptions.perennial)
            } else {
              this.totals.shortTerm = { dev: 0, main: 0, res: 0, all: 0 }
              this.costs.shortTerm = this.cleanSource(fields.costs.shortTerm)
              this.assumptions.shortTerm = this.cleanSource(fields.assumptions.shortTerm)
            }
          } else {
            let activeScenario:Scenario = this.scenario
            Object.assign(this.$data, this.$options.data.apply(this))
            this.scenario = activeScenario
          }
        }
      } else {
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },

    // Delete the selected scenario
    deleteScenario: async function (this:any, name:string) {
      if (await this.$refs.confirm.open(
        'Delete scenario',
        'Are your sure you want to delete this scenario: ' + name,
        {
          color: 'red',
          cta: 'Okay'
        }
      )) {
        let index = store.state.scenarios.map((s:Scenario) => { return s.text }).indexOf(name)
        if (index >= 0) {
          if (store.state.scenarios[index].text === store.state.selectedScenario.text) {
            this.clearScenario(true)
            this.selectedScenario = null
          }
          store.state.scenarios.splice(index, 1)
        }
      }
    },

    // MISC FUNCTIONS

    // Value change event
    change: function (this:any, newValue:any, item:any, field:string, table:string) {
      if (table === 'costs') {
        let index = this.costsLC.indexOf(item)
        // If field is not empty and equal to rate, price or type, assing data value
        if (field === 'rate' && this.costsLC[index].rate !== null) {
          this.costsLC[index].rate.value = newValue
        } else if (field === 'price') {
          this.costsLC[index].price.value = newValue
        } else if (field === 'type') {
          this.costsLC[index].type = newValue
        }
        // If rate is not null multiply by price, else return price only
        if (this.costsLC[index].rate !== null) {
          this.costsLC[index].cost = this.costsLC[index].rate.value * this.costsLC[index].price.value
        } else if (this.costsLC[index].price.value !== null) {
          this.costsLC[index].cost = this.costsLC[index].price.value
        } else {
          this.costsLC[index].cost = 0
        }
        // If not a number, return 0
        if (isNaN(this.costsLC[index].cost)) {
          this.costsLC[index].cost = 0
        }
        this.updateCostsKey += 1
      } else if (table === 'assumptions') {
        let index = this.assumptionsLC.indexOf(item)
        if (field === 'value') {
          this.assumptionsLC[index].value = newValue
        }
      }
    },

    // Get the index of the section - used to position the total rows in table
    totalIndex: function (this:any, section:string) {
      let index = this.costsLC.map((e:Cost) => e.section).indexOf(section)
      return index
    },

    // Get the total cost value of a given range
    getTotal: function (this:any, range:any[]) : number {
      let total:number = 0
      for (let i = range[0]; i <= range[1]; i++) {
        if (this.costsLC[i] !== undefined) {
          if (this.costsLC[i].rate && this.costsLC[i].section.toLowerCase().includes('paddock infrastructure')) {
            total += parseFloat(this.getCostPerHa(this.costsLC[i].cost))
          } else if (this.costsLC[i].section.toLowerCase().includes('additional livestock labour')) {
            total += parseFloat(this.costsLC[i].cost) * this.assumptionsLC.filter((a:Assumption) => a.id === 'stockingRateAfter')[0].value
          } else if (this.costsLC[i].rate && this.costsLC[i].section.toLowerCase().includes('fertiliser')) {
            total += parseFloat(this.costsLC[i].cost) / 1000
          } else {
            total += parseFloat(this.costsLC[i].cost)
          }
        }
      }
      return total || 0
    },

    getTotalResidual: function (this:any) : number {
      let residuals = this.assumptionsLC.filter((alc:Assumption) => alc.section === 'Residual').map((r:Assumption) => r.value)
      return residuals.reduce((a:any, b:any) => (parseFloat(a) || 0) + (parseFloat(b) || 0))
    },

    // Duplicate table row
    duplicate: function (this:any, item:Cost) {
      let index = this.costsLC.indexOf(item)
      let newItem = {
        duplicate: true,
        section: item.section,
        type: item.type,
        rate: {
          value: 0,
          unit: item.rate ? item.rate.unit : null
        },
        price: {
          value: 0,
          unit: item.price ? item.price.unit : null
        },
        cost: 0
      }
      this.costsLC.splice(index + 1, 0, newItem)
      this.updateCostsKey += 1
    },

    // Remove duplicated row
    remove: function (this:any, item:Cost) {
      let index = this.costsLC.indexOf(item)
      this.costsLC.splice(index, 1)
      this.updateCostsKey += 1
    },

    // Save and continue
    saveContinue: function (this:any) {
      this.saveScenario()
      this.saved.status = false
      this.validation().then((valid:boolean) => {
        if (valid) {
          this.$router.push({ name: 'Results' })
        }
      })
    },

    validation: async function (this:any) {
      // console.log('Errors: ', store.state.errors)
      if (this.$refs.generalAssumptions && this.$refs.confirm) {
        (this.$refs.generalAssumptions as Vue & { validate: () => boolean }).validate()
        const missing = this.assumptionsLC.filter((a:Assumption) => (a.value === null || a.value === undefined || a.value === '' || a.value < 0))
        if (!this.areasLC) {
          await this.$refs.confirm.open(
            'Area improved',
            'Please enter the area improved (ha)',
            {
              color: 'red',
              cta: 'Okay'
            }
          )
        } else if (isNaN(this.totalsLC.all) || this.totalsLC.all <= 0) {
          await this.$refs.confirm.open(
            'Development & maintenance',
            'Total cost cannot be $0',
            {
              color: 'red',
              cta: 'Okay'
            }
          )
        } else if (missing.length > 0) {
          await this.$refs.confirm.open(
            'General assumptions',
            'Missing or invalid data: ' + missing[0].type + (missing && missing.length > 1 ? ' and (' + (missing.length - 1) + ') other/s...' : ''),
            {
              color: 'red',
              cta: 'Okay'
            }
          )
        } else {
          return true
        }
      }
      return false
    }
  },

  beforeDestroy (this:any) {
    this.saveScenario()
  },

  store
}
